import { gql, useMutation } from '@apollo/client'

import {
  JusIaCreateThreadMutation,
  JusIaCreateThreadMutationVariables,
} from './__generated__/use-create-thread.graphql'

const JUSIA_CREATE_THREAD_MUTATION = gql`
  mutation jusIaCreateThread($input: JusIaCreateThreadInput!) {
    jusIaCreateThread(input: $input) {
      thread {
        id
      }
    }
  }
`

interface UseCreateThreadOutput {
  createThread: (resourceId: number) => Promise<string | null>
}

export function useCreateThread(): UseCreateThreadOutput {
  const [mutate] = useMutation<JusIaCreateThreadMutation, JusIaCreateThreadMutationVariables>(
    JUSIA_CREATE_THREAD_MUTATION
  )

  const createThread = async (resourceId: number) => {
    const response = await mutate({
      variables: {
        input: { resourceId: resourceId.toString() },
      },
    })
    return response.data?.jusIaCreateThread?.thread?.id ?? null
  }

  return { createThread }
}
